import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgChevronUp(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        d="M16.0001 13.2678L7.00007 22.2678L5.2323 20.5L15.1162 10.6161C15.2159 10.5164 15.3307 10.4353 15.4552 10.375C15.6235 10.2935 15.8095 10.25 16.0001 10.25C16.0001 10.25 16.0001 10.25 16.0001 10.25C16.2073 10.25 16.4092 10.3014 16.5887 10.3973C16.6964 10.4547 16.796 10.5282 16.884 10.6161L26.7678 20.5L25.0001 22.2678L16.0001 13.2678Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgChevronUp);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
